<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['name', { rules: [{ required: true, message: '请输入姓名' }] }]"
            name="name"
            placeholder="请输入姓名"
          />
        </a-form-item>
        <a-form-item label="职位" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
          <a-textarea
            rows="4"
            name="title"
            placeholder="请输入职位"
            v-decorator="['title']"

          />
        </a-form-item>
        <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            rows="4"
            name="desc"
            placeholder="请输入简介"
            v-decorator="['desc', { rules: [{ required: true, message: '请输入简介' }] }]"
          />
        </a-form-item>
        <a-form-item label="所属身份" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="请选择身份"
            style="width: 100%"
            name="identity"
            mode="multiple"
            optionFilterProp="children"
            allow-clear
            v-decorator="['identity', { rules: [{ required: true, message: '请选择身份' }] }]"
          >
            <a-select-option v-for="(identity, key) in identityList" :key="key">{{
              identity
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-form-item
          label="合作机构"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-spin :spinning="orgLoad">
            <a-select
              placeholder="请选择合作机构"
              name="organization"
              optionFilterProp="children"
              allow-clear
              v-decorator="['organization']"
            >
              <a-select-option v-for="val in orgLists" :key="val.id">
                {{ val.name }}
              </a-select-option>
            </a-select>
          </a-spin>
        </a-form-item> -->
        <a-form-item label="个人照片" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <img-upload
            name="logo"
            v-decorator="['logo', { rules: [{ required: true, message: '请上传个人照片' }] }]"
          />
        </a-form-item>
        <!--
        <a-form-item label="内容" :labelCol="labelCol" :wrapperCol="{ lg: { span: 18 }, sm: { span: 18 } }">
          <u-editor
            name="description"
            v-decorator="['description']"

          />
        </a-form-item> -->
        <a-form-item label="证书" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="请选择证书"
            name="certificates"
            mode="multiple"
            optionFilterProp="children"
            allow-clear
            v-decorator="['certificates']"
          >
            <a-select-option v-for="crt in crtsList" :key="crt.id.toString()">
              {{ crt.title }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <!-- <a-form-item label="课程" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            placeholder="选择课程"
            style="width: 100%"
            name="courses"
            mode="multiple"
            optionFilterProp="children"
            allow-clear
            v-decorator="[
              'courses'
            ]"
          >
            <a-select-option v-for="item in coursesLists" :key="item.id.toString()">
              {{ item.title }}
            </a-select-option>
          </a-select>
        </a-form-item> -->

        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="是否在前端展示，默认展示">
          <a-switch
            checked-children="展示"
            un-checked-children="隐藏"
            name="state"
            v-decorator="[
              'state',
              {
                valuePropName: 'checked',
                initialValue: true
              }
            ]"
          />
        </a-form-item>
        <a-form :form="form">
          <a-form-item label="Github" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              v-decorator="['github', { rules: [{ type: 'url', message: '请输入正确的链接' }] }]"
              name="github"
              placeholder="请输入Github"
            />
          </a-form-item>
          <a-form :form="form">
            <a-form-item label="Gitee" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                v-decorator="['gitee', { rules: [{ type: 'url', message: '请输入正确的链接' }] }]"
                name="gitee"
                placeholder="请输入Gitee"
              />
            </a-form-item>
            <a-form :form="form">
              <a-form-item label="blog" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input
                  v-decorator="['blog', { rules: [{ type: 'url', message: '请输入正确的链接' }] }]"
                  name="blog"
                  placeholder="请输入博客"
                />
              </a-form-item>
              <a-form :form="form">
                <a-form-item label="mail" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input
                    v-decorator="['mail']"
                    name="mail"
                    placeholder="请输入邮箱"
                  />
                </a-form-item>

                <a-form-item label="技能" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
                  <a-textarea
                    rows="4"
                    name="skill"
                    placeholder="请输入技能"
                    v-decorator="['skill']"

                  />
                </a-form-item>
                <a-form-item label="奖项" :labelCol="labelCol" :wrapperCol="wrapperCol" help="注：英文逗号隔开">
                  <a-textarea
                    rows="4"
                    name="awards"
                    placeholder="请输入奖项"
                    v-decorator="['awards']"

                  />
                </a-form-item>
                <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
                  <a-button :loading="formLoading" @click="handleOnSubmit(setFormData)" type="primary">提交</a-button>
                </a-form-item>
              </a-form>
            </a-form></a-form></a-form></a-form></a-card>
  </page-header-wrapper>
</template>

<script>
import { ImgUpload, UEditor, GoBack } from '@/components'
import { requestData } from '@/api/api'
import { form, select } from '@/mixins'

const fields = ['name', 'title', 'logo', 'organization', 'desc', 'github', 'state', 'identity', 'certificates', 'courses', 'awards', 'skill', 'gitee', 'blog', 'mail']
const apiList = {
    getInfo: '/partners/',
    coursesLists: '/courses/select',
    crtsList: '/certificates/select',
    create: '/partners/create/teacher',
    orgLists: '/partners/select/organization'
}
export default {
    name: 'TeacherForm',
    mixins: [form, select],
    components: {
        ImgUpload,
        UEditor,
        GoBack
    },
    data () {
        return {
            apiList,
            fields,
            identityList: {
                1: 'SIG',
                2: 'LFAI',
                3: '开源布道者'
            },
            crtsLoading: false, // 获取下拉加载
            crtsList: [], // 分类下拉数据
            orgLists: [],
            // orgLoad: true,
            coursesLists: []
        }
    },
    mounted () {
        this.getSelectLists({
            url: apiList.crtsList,
            type: 'crtsList',
            load: 'crtsLoading'
        }) // 获取下拉分类列表
        this.getSelectLists({
            url: apiList.coursesLists,
            type: 'coursesLists'
        }) // 获取下拉分类列表
        // this.getSelectLists({
        //     url: apiList.orgLists,
        //     type: 'orgLists',
        //     load: 'orgLoad'
        // })
        if (this.$route.params.id) {
            apiList.update = '/partners/' + this.$route.params.id + '/teacher'
            this.getFormData(this.$route.params.id, function (values) {
                values.state = values.state === 1
            }) // 获取编辑信息
        }
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-28 15:09:22
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:整理表单数据
         * @param  {*}
         * @return {*}
         * @param {*} values
         */
        setFormData (values) {
            values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
        },
        /**
         * 表单提交
         * @param {*} e
         * @jdy
         * @2021-4-14
         */
        handleOnSubmit (callback) {
            const that = this
            const { apiList } = this

            that.form.validateFields((err, values) => {
                if (!err) {
                    that.formLoading = true // 表单加载
                    if (callback) {
                        callback(values)
                    }
                    let method = 'post'
                    let url = apiList.create
                    if (this.$route.params.id) {
                        method = 'put'
                        url = apiList.update
                    }
                    requestData(url, method, values)
                        .then(res => {
                            that.$notification.success({
                                message: res.msg
                            })
                        })
                        .finally(() => {
                            that.formLoading = false // 执行完加载关闭
                        })
                }
            })
        }
    }
}
</script>
